import { CancelIcon, SaveIcon } from '@/assets/icons';
import { cn } from '@/utils';
import { memo } from 'react';

interface EditActionsProps {
	onCancel?: () => void;
	onSave?: () => void;
	className?: string;
	hiddenSave?: boolean;
}

const EditActions = ({
	onCancel,
	onSave,
	className,
	hiddenSave,
}: EditActionsProps) => {
	return (
		<div
			className={cn('edit-actions-input flex items-center gap-1', className)}
		>
			<div
				onClick={onCancel}
				className="action-cancel cursor-pointer w-[18px] h-[18px] flex items-center justify-center hover:border hover:border-gray1 rounded-sm"
			>
				<CancelIcon />
			</div>
			{!hiddenSave && (
				<div
					onClick={onSave}
					className="action-save cursor-pointer w-[18px] h-[18px] flex items-center justify-center hover:border hover:border-gray1 rounded-sm"
				>
					<SaveIcon />
				</div>
			)}
		</div>
	);
};

export default memo(EditActions);
